module.exports = __webpack_public_path__ + "static/img/Frame601.402b00c6.png";